import { ThirdPartyTracingActionListItem } from './thirdparty-tracingaction-listitem';

export class ThirdPartyEvaluationResult {
    stageName: string;
    name?: string;
    score: number;
    currentStageId: number = 0;
    nextStagInAppFormId: number = 0;
    // TODO: Revisar el nombre de la propiedad (es next...?)
    nextStageAppFormDescription: string = "";
    isFinalStage: boolean =  false;
    thridPartyId: number = 0;
    evaluationId: number = 0;
    workFlowAction: number = 2;
    level: {
      id: number,
      value: number,
      description: string,
      color?: string
    };
    isNextAppFormAvailable: boolean = false;

    isBeforeFinalStage: boolean = false;
    tracingActions: ThirdPartyTracingActionListItem[];

    constructor() {
        this.stageName = '';
        this.level = {
            id: 0,
            value: 0,
            description: ''
        };
    }
}
